export var getNewList = function (selectedItems, changedItems, actionType, isEqual) {
    if (actionType === 'removed') {
        return selectedItems.filter(function (selectedItem) {
            return !changedItems.some(function (changedItem) {
                return isEqual(selectedItem, changedItem);
            });
        });
    }
    return selectedItems
        .concat(changedItems)
        .filter(function (itemA, i, arr) {
        return arr.findIndex(function (itemB) { return isEqual(itemA, itemB); }) === i;
    });
};
export var getActionType = function (selectedList, clickedElement, isEqual) {
    return (selectedList === null || selectedList === void 0 ? void 0 : selectedList.some(function (selectedItem) { return isEqual(selectedItem, clickedElement); }))
        ? 'removed'
        : 'selected';
};
